import styles from "./info.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import { stack } from "./stack";

const Info = () => {
  return (
    <div className={styles.info}>
      <img src="/logo.svg" alt="logo" />
      <div style={{ paddingLeft: 30, paddingRight: 30 }}>
        <p className={styles.info__text}>
          Фкор — <span>Премиальное digital агентство</span>, которое занимается
          разработкой мобильных приложений и веб-плафторм
        </p>
        <a href="./fcore.pdf" download={true} className={styles.info__download}>
          <img src="./download.svg" alt="" className={styles.download__img} />
          Скачать презентацию
        </a>
      </div>

      <div className={styles.info__stats}>
        <div className={styles.stat}>
          <p className={styles.stat__value}>2022</p>
          <p className={styles.stat__name}>год основания</p>
        </div>
        <div className={styles.stat}>
          <p className={styles.stat__value}>31</p>
          <p className={styles.stat__name}>сотрудник</p>
        </div>
        <div className={styles.stat}>
          <p className={styles.stat__value}>41</p>
          <p className={styles.stat__name}>клиент</p>
        </div>
        <div className={styles.stat}>
          <p className={styles.stat__value}>10+</p>
          <p className={styles.stat__name}>партнеров</p>
        </div>
      </div>
      <div className={styles.info__stack}>
        <p className={styles.info__title}>{"// Наш стек"}</p>
        <Swiper
          className={styles.stack__wrap}
          slidesPerView={1.2}
          spaceBetween={10}
          centeredSlides={true}
          loop={true}
        >
          {stack.map((item, index) => (
            <SwiperSlide key={index} className={styles.stack}>
              <img
                src={item.image}
                alt={item.name}
                className={styles.stack__img}
              />
              <div className={styles.stack__info}>
                <p className={styles.stack__name}>{item.name}</p>
                <p className={styles.stack__description}>{item.description}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};
export default Info;
